import { axiosIns } from './index';
import { ApiResponse } from '../typings/ApiResponse';
import { StatisticsData } from '../typings/Statistics';

const getResidientStatistics = async (
  partnerId: string
): Promise<ApiResponse<StatisticsData>> => {
  const response = await axiosIns.get(
    `carehome/residents/overview-info/${partnerId}`
  );
  return response.data;
};

export default getResidientStatistics;
